import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

import { isExternalAccessEntityNotFoundError } from '@components/ContactDetails/ContactDetailsHeader/contactDetails-externalAccess.helpers';

const getContactExternalAccess = async (contactId) => {
    try {
        const response = await Axios.get(`/contactgateway/access/${contactId}`);
        return response ?? null;
    } catch (error) {
        // The backend returns an EntityNotFound error when the contact has no external access yet;
        // normalize that to `null` so consumers can treat the absence of data consistently.
        if (isExternalAccessEntityNotFoundError(error)) {
            return null;
        }
        throw error;
    }
};

const useContactExternalAccess = (contactId) => {
    const disableQuery = !contactId || isNaN(parseInt(contactId));
    const intID = !disableQuery ? parseInt(contactId) : null;
    return useQuery({
        queryKey: ['contactExternalAccess', intID],
        queryFn: () => getContactExternalAccess(intID),
        enabled: !disableQuery,
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
    });
};

const forceReloadContactExternalAccess = (contactId) => {
    if (contactId == null) {
        queryClient.invalidateQueries({ queryKey: ['contactExternalAccess'] });
        return;
    }
    const intID = Number(contactId);
    queryClient.invalidateQueries({ queryKey: ['contactExternalAccess', intID] });
};

export { useContactExternalAccess, forceReloadContactExternalAccess };
